/* eslint-disable no-unused-vars */
import { ALERT_DISMISS, ALERT_SHOW } from './alertActionTypes';

const alertinitialState = {
    showAlert: false,
    alertType: 'error',
    alertMeta: {
        message: '',
        status: 200,
    },
};

const alertReducer = (state = alertinitialState, { type, payload }) => {
    switch (type) {
        case ALERT_SHOW:
            return {
                ...state,
                showAlert: true,
                alertType: payload.alertType,
                alertMeta: {
                    ...state.alertMeta,
                    message: payload.message,
                    status: payload.status,
                },
            };
        case ALERT_DISMISS:
            return {
                ...state,
                showAlert: false,
            };

        default:
            return state;
    }
};

export default alertReducer;
